import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import { Topic } from "./Topic.model";

export interface CreateTopicPayload {
  topic: string;
  description?: string;
}

export interface UpdateTopicPayload {
  id: number;
  topic?: string;
  description?: string;
}

export interface MergeTopicPayload {
  fromTopicId: number;
  toTopicId: number;
}

export function useTopicApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      getTopics: async () =>
        apiResolver<Topic[]>(api.get("/platform/dashboard/topics")),
      createTopic: async (input: CreateTopicPayload) =>
        apiResolver<Topic>(api.post("/platform/topic", input)),
      updateTopic: async (topicId: number, input: UpdateTopicPayload) =>
        apiResolver<Topic>(api.put(`/platform/topic/${topicId}`, input)),
      mergeTopic: async (input: MergeTopicPayload) =>
        apiResolver<{ success: boolean }>(
          api.post("/platform/topic/merge", input)
        ),
    }),
    [api]
  );
}
